import { createApp } from 'vue'
import { createPinia } from 'pinia'

import router from './router'
import App from './App.vue'
import moment from "moment";
import { defineRule } from "vee-validate";
import * as bootstrap from 'bootstrap';
import { roleName } from "./enums/roles.js";
import { shirtSizeName } from "./enums/shirtsizes.js";

import * as Sentry from '@sentry/vue';

const app = createApp(App)
Sentry.init({
    app,
    release: "v1.6.1",
  dsn: "https://b27f338e30cf36fb718b2e0f326b4706@o4506592201867264.ingest.us.sentry.io/4509553364172800",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

app.use(router)
app.use(createPinia())

defineRule('required', value => {
    if (!value) {
        return 'Dieses Feld ist ein Pflichtfeld.';
    }

    return true;
});
defineRule('phoneGerman', value => {
    if (!value) { return true }
    if (!value.match(/^(0049|\+49|0)/)) {
        return 'Das ist keine deutsche Telefonnummer man. Das wird zu teuer!';
    }
    return true;
})
defineRule('phoneMobile', value => {
    if (!value) { return true }
    if (!value.match(/^(0049|\+49|0)1(5|6|7)[0-9 -]{4,13}$/)) {
        return 'Sieht so aus, als ist die Handynummer falsch.';
    }
    return true;
})
defineRule('phoneService', value => {
    if (!value) { return true }
    if (value.match(/^(((\+49|0049|0)(10|11|12|13|14|18|19|31|32|700|701|800|801|900|901|902|903|904|905))|110|112|115|116|118)/)) {
        return 'Eeeyy! Das ist ne Servicenummer';
    }
    return true;
})
defineRule("confirmedPassword", (value, [other]) => {
    if (value !== other) {
        return `Die Passwörter stimmen nicht überein`;
    }

    return true;
});
defineRule("confirmedEmail", (value, [other]) => {
    if (value !== other) {
        return `Die E-Mail Adressen stimmen nicht überein`;
    }

    return true;
});
defineRule("uniqueTeamlead", (value, [idx], ctx) => {
    const teamleads = ctx.form["teamleads"]
    for (let i in teamleads) {
        if (i !== idx && teamleads[i] === value) {
            return "Der Teamlead existiert schon."
        }
    }
    return true
})
defineRule("min", (value, [min]) => {
    if(!value) {
        return true
    }
    if (value.length < min) {
        return `Das muss mindestens ${min} Zeichen lang sein.`;
    }
    return true
});
defineRule("uuid", (value) => {
    if (!value) {
        return true;
    }
    let s = "" + value;
    s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    if (s === null) {
        return "Das ist keine gültige UUID";
    }
    return true;
})

app.config.globalProperties.$filters = {
    formatDate(value, format) {
        if (value) {
            return moment(String(value)).format(format)
        }
    },
    yesNo(value) {
        return value ? 'Ja' : 'Nein';
    },
    roleName,
    shirtSizeName
}

app.mount('#app')
